export const configuration = {
  header: {
    heading: "Steticap website",
    headingtext:
      "Clinica Steticap",
    buttontext: "do some action",
    buttonlink: "home",
  },
};
